import { useReactiveVar } from "@apollo/client";
import { robotsState } from "../state";
import { ArtifactNamesKeysMap, ArtifactNamesMap } from "../maps";
import { ArtifactsNameEnum } from "../types";

export const useGetArtifactsTypes = () => {
  const artifactClothTypes = useReactiveVar(robotsState.artifactClothTypes);

  const getArtifactTypes = (value: ArtifactsNameEnum) => {
    const name = ArtifactNamesKeysMap.get(value);

    const type = ArtifactNamesMap.get(value);
    const clothTypeId = artifactClothTypes?.find(
      (item) => item?.name === name
    )?.id;

    return { type, clothTypeId };
  };

  return getArtifactTypes;
};
